import {notification,} from 'antd';


const notifyError = (response, objDescription, action, info) => {
  console.error(response.status + " " + response.statusText + " [" + objDescription + " " + action + "]"+
    (info === "" ? "" : ":" + info));
  notification.error({
    message: "Error: " + response.status + " " + response.statusText,
    description: objDescription + " " + action + " failed" + (info === "" ? "" : ":" + info),
    placement: 'bottomRight',
    duration: 10
  });
}

const notifySuccess = (objDescription, action) => {
  notification.success({
    message: 'Success',
    description: objDescription + " " + action + "!",
    placement: 'bottomRight',
  });
}

const notifyWarning = (objDescription, action, warning) => {
  notification.warning({
    message: 'Warning',
    description: objDescription + " " + action + " : " + warning,
    placement: 'bottomRight',
  });
}

export const handleResponse = (response, objDescription, action) => {
  if (response) {
    if (response.status && (response.status === "ok" || response.status === 200)) {
      response.clone().text().then(body => {
        try {
          const msg = JSON.parse(body);
          if (msg.warning) {
            notifyWarning(objDescription, action, msg.warning);
          } else {
            notifySuccess(objDescription, action);
          }
        } catch (e) {
          notifySuccess(objDescription, action);
        }
      })
    } else {
      response.text().then(body => {
        try {
          const msg = JSON.parse(body);
          if (msg.error) {
            notifyError(response, objDescription, action, msg.error);
          } else {
            notifyError(response, objDescription, action, "");
          }
        } catch (e) {
          notifyError(response, objDescription, action, body);
        }
      }).catch(() => {
        notifyError(response, objDescription, action, "");
      });
    }
  }
};
